var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"cursor":"pointer","display":"flex","justify-content":"center","align-items":"center"}},[_c('b-button',{staticClass:"is-small mr-2",class:_vm.size,staticStyle:{"cursor":"pointer"},on:{"click":_vm.triggerFunction}},[_c('b-icon',{attrs:{"icon":_vm.icon,"type":_vm.type? _vm.type: ''}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }